"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ArrowUpward = function ArrowUpward(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.16,5.36,5.63,10.82l-.26.25a1.22,1.22,0,0,0,0,1.75,1.28,1.28,0,0,0,1.78,0l3.64-3.6v8.54a1.26,1.26,0,0,0,2.52,0V9.22l3.54,3.47a1.26,1.26,0,0,0,1.78,0,1.19,1.19,0,0,0,.37-.87,1.25,1.25,0,0,0-.32-.82L18.63,11,12.94,5.36A1.28,1.28,0,0,0,11.16,5.36Z"
  }));
};

var _default = ArrowUpward;
exports["default"] = _default;